export const Fonts = {
  base: '"Poppins", sans-serif',
  secondary: '"RobotoSlab", sans-serif',
};
